export default "__VITE_PUBLIC_ASSET__0581070f__"